"use strict";

module.exports = function ($stateProvider) {
  $stateProvider.state("dashboard.clients", {
    url: "/clients",
    templateUrl: "dashboard-clients/dashboard-clients.html",
    controller: "dashboardClientsCtrl as ctrl",
    resolve: {
      clients: [
        "Client",
        function (Client) {
          return Client.find({
            filter: {
              include: ["owners","parent","members"],
            },
          }).$promise.then(function (clients) {            
            return clients
          });
        },
      ],
    },
    data: {
      authorizedRoles: ["admin", "mobileUser"],
    },
  });
};
